module.exports = __webpack_public_path__ + "assets/img/Vip_mpic2.75bfa8c0.png";